const ID_TOKEN_KEY_OPERATOR = 'tpsre.operator'
const ID_TOKEN_KEY_USER = 'tpsre.user'

export const getOperator = () => {
  return JSON.parse(window.localStorage.getItem(ID_TOKEN_KEY_OPERATOR))
}

export const saveOperator = operator => {
  window.localStorage.setItem(ID_TOKEN_KEY_OPERATOR, JSON.stringify(operator))
}

export const destroyOperator = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY_OPERATOR)
}

export const getUser = () => {
  return JSON.parse(window.localStorage.getItem(ID_TOKEN_KEY_USER))
}

export const saveUser = user => {
  window.localStorage.setItem(ID_TOKEN_KEY_USER, JSON.stringify(user))
}

export const destroyUser = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY_USER)
}

export default {getOperator, saveOperator, destroyOperator, getUser, saveUser, destroyUser}



// WEBPACK FOOTER //
// ./src/common/auth.service.js